import { CartModal } from '@/components/Cart/modal/CartModal';
import { HeaderSection } from '@/components/Common/HeaderSection/HeaderSection';
import { NavigationTabs } from '@/components/Common/NavigationTabs/NavigationTabs';
import { useCartContext } from '@/context/Cart/CartContext';
import TopLevelSectionLayout from '@/layouts/TopLevelSectionLayout/TopLevelSectionLayout';

export function CartDirectory() {
  const { setOpenModal } = useCartContext();

  return (
    <TopLevelSectionLayout>
      <HeaderSection
        title={'Carritos'}
        sx={{
          px: { xs: '16px', md: '0px' },
          pb: { xs: '0px', md: '16px' },
        }}
        primaryButton={{
          label: 'Crear Carrito',
          variant: 'contained',
        }}
        onPrimaryButtonClicked={() => setOpenModal?.({ type: 'create' })}
      />
      <NavigationTabs links={[{ to: '/carts', label: 'Todos los carritos' }]} />
      <CartModal />
    </TopLevelSectionLayout>
  );
}
